import React, { useState, useEffect, useMemo } from "react";
import Select from "react-select";
import { Search } from 'lucide-react';
import { MdPrint } from "react-icons/md";
import classes from "./ViewAssets.module.css";
// import plus from "../../../../Assets/plus.svg"
import { FaEdit, FaPen } from 'react-icons/fa';
// import DeleteIcon from "../../../../Assets/new-delete.svg"
import { Spinner, Badge, Button, Modal, Form, Alert, Table } from 'react-bootstrap';
import HeaderNav from "../../Accoungting/HeaderNav/FixedAssetNav";
import axios from "axios";
import { BASE_URL, TOKEN, BASE_URL1 } from "../../../Components/Styles/API/API";
// "../../../../Components/Styles/API/API";
import { useNavigate, useLocation } from "react-router-dom";
import Swal from "sweetalert2";
import { Pencil } from "lucide-react";
import CurrencyInput from 'react-currency-input-field';
// import ToggleSlider from "./ToggleSlider";
import Pic from '../../../Assets/img.png'
import Pdf from '../../../Assets/pdf.png'

const ViewAsset = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { selectedAsset } = location.state || {};
  const [searchTerm, setSearchTerm] = useState("");
  const { parishID } = location.state || {};
  const [showCreateUserModal, setShowCreateUserModal] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [show1, setShow1] = useState(false);
  const handleClose1 = () => setShow1(false);
  const [error, setError] = useState("");
  const [modalError, setModalError] = useState("");
  const [success, setSuccess] = useState("");
  const [bearer, setBearer] = useState('');
 
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [perPage, setPerPage] = useState(10);
  const [totalUsers, setTotalUsers] = useState(0);
  const [selectedType, setSelectedType] = useState("");
  const [fullName, setFullName] = useState("");
  const [fullName1, setFullName1] = useState("");
  const [email, setEmail] = useState("");
  const [email1, setEmail1] = useState("");
  const [phone1, setPhone1] = useState("");
  const [selectedRole1, setSelectedRole1] = useState("");
  const [phone, setPhone] = useState("");
  const [description, setDescription] = useState("");
  const [userType, setUserType] = useState([]);
  const [zones, setZones] = useState([]);

  // Main filter states
  const [selectedProvince, setSelectedProvince] = useState(null);
  const [provinces, setProvinces] = useState([]);
  const [provLoading, setProvLoading] = useState(false);

  // React Select states for filters
  const [selectedContinent, setSelectedContinent] = useState(null);
  const [selectedRegion, setSelectedRegion] = useState(null);
  const [continents, setContinents] = useState([]);
  const [regions, setRegions] = useState([]);
  const [contLoading, setContLoading] = useState(false);
  const [regionLoading, setRegionLoading] = useState(false);

  // React Select states for modal
  const [selectedContinentModal, setSelectedContinentModal] = useState(null);
  const [regionsModal, setRegionsModal] = useState([]);
  const [provincesModal, setProvincesModal] = useState([]);

  const [tableData, setTableData] = useState([]);
  const [tableData1, setTableData1] = useState([]);
  const [editingUser, setEditingUser] = useState(null);
  const [searchLoading, setSearchLoading] = useState(false);
  const [selectedItemId, setSelectedItemId] = useState(null);
  const [viewLoading, setViewLoading] = useState(false);
  const [totalEntries, setTotalEntries] = useState("");
  // const [totalPages, setTotalPages] = useState(1);
  const [areas, setAreas] = useState([]);


  const [selectedZone, setSelectedZone] = useState('');
  const [selectedArea, setSelectedArea] = useState('');
  const [continentName, setContinentName] = useState(null);
  const [continentID, setContinentID] = useState(null);
  const [regionID, setRegionID] = useState(null);
  const [regionName, setRegionName] = useState(null);
  const [provinceID, setProvinceID] = useState(null);
  const [provinceName, setProvinceName] = useState(null);

  const [approvalLoading, setApprovalLoading] = useState(false);
  const [disApprovalLoading, setDisapprovalLoading] = useState(false);
  const [createLoading, setCreateLoading] = useState(false);


  // Get token from localStorage
  const readData = async () => {
    try {
      const value = await localStorage.getItem('userToken');
      const value4 = await localStorage.getItem('provinceID');
      const value5 = await localStorage.getItem('regionID');
      const value6 = await localStorage.getItem('continentID');
      const conName = await localStorage.getItem('continent');
      const proName = await localStorage.getItem('province');
      const regName = await localStorage.getItem('region');

      if (value !== null) {
        setBearer(value);
      }
      if (value4 !== null) {
        setProvinceID(value4);
      }
      if (value5 !== null) {
        setRegionID(value5);
      }
      if (value6 !== null) {
        setContinentID(value6);
      }
      if (conName !== null) {
        setContinentName(conName);
      }
      if (proName !== null) {
        setProvinceName(proName);
      }
      if (regName !== null) {
        setRegionName(regName);
      }
    } catch (e) {
      console.error('Failed to fetch token from storage');
    }
  };

  useEffect(() => {
    readData();
  }, []);

  const headers = {
    'Content-Type': 'application/json',
    'Authorization': `Bearer ${bearer}`
  };


  const goBack = () => {
    navigate(-1);
  }
 
  const searchUsers = async (searchQuery, page = 1) => {
    if (!bearer) {
      return;
    }

    setSearchLoading(true);
    setError("");
    setSuccess("");

    try {
      const response = await axios.get(`${BASE_URL}/users/search`, {
        headers,
        params: {
          variable: searchQuery,
          page: page
        }
      });

      console.log('Search API Response:', response);

      let usersData = [];
      let total = 0;
      let lastPage = 1;
      let currentPage = page;

      if (response.data && response.data.data) {
        if (Array.isArray(response.data.data)) {
          usersData = response.data.data;
          total = usersData.length;
        }
        else if (response.data.data.data && Array.isArray(response.data.data.data)) {
          usersData = response.data.data.data;
          total = response.data.data.total || usersData.length;
          lastPage = response.data.data.last_page || 1;
          currentPage = response.data.data.current_page || page;
        }
        else if (response.data.data.users && Array.isArray(response.data.data.users)) {
          usersData = response.data.data.users;
          total = response.data.data.total || usersData.length;
          lastPage = response.data.data.last_page || 1;
          currentPage = response.data.data.current_page || page;
        }
        else {
          const dataObj = response.data.data;
          const arrayKeys = Object.keys(dataObj).filter(key => Array.isArray(dataObj[key]));
          if (arrayKeys.length > 0) {
            usersData = dataObj[arrayKeys[0]];
            total = dataObj.total || usersData.length;
            lastPage = dataObj.last_page || 1;
            currentPage = dataObj.current_page || page;
          } else {
            usersData = [dataObj];
            total = 1;
          }
        }
      } else if (Array.isArray(response.data)) {
        usersData = response.data;
        total = usersData.length;
      }

      setUsers(usersData);
      setTotalUsers(total);
      setTotalPages(lastPage);
      setCurrentPage(currentPage);

    } catch (error) {
      console.error("Error searching users:", error);
      setUsers([]);
      setTotalPages(1);
      setCurrentPage(1);
      setTotalUsers(0);
    } finally {
      setSearchLoading(false);
      setLoading(false);
    }
  };

  // Handle search input change with debounce
  useEffect(() => {
    const delayDebounceFn = setTimeout(() => {
      if (searchTerm.trim()) {
        setCurrentPage(1);
        searchUsers(searchTerm, 1);
      } else if (searchTerm === "") {
        setCurrentPage(1);
        // fetchUsers(1);
      }
    }, 500);

    return () => clearTimeout(delayDebounceFn);
  }, [searchTerm]);



  // Fetch continents for React Select
  const fetchContinents = async () => {
    setContLoading(true);
    try {
      const response = await axios.get(`${BASE_URL}/continents`, { headers });
      const contList = response.data?.data;
      const options = contList.map((item) => ({
        label: item.description,
        value: item.id,
      }));

      const continentsWithAll = [
        { label: "All Continents", value: "all" },
        ...options
      ];

      setContinents(continentsWithAll);
    } catch (error) {
      if (error.response && error.response.status === 401) {
        navigate('/login');
      } else {
        console.error("Error fetching continents:", error);
        setContinents([{ label: "All Continents", value: "all" }]);
      }
    } finally {
      setContLoading(false);
    }
  };

  

  // Auto-fetch users when filters change
  useEffect(() => {
    if (bearer) {
      setCurrentPage(1);
      // fetchUsers(1);
    }
  }, [selectedContinent, selectedRegion, selectedProvince, bearer]);

  // Fetch user types for dropdown
  const fetchData1 = async () => {
    setIsLoading(true);
    try {
      const response = await axios.get(`${BASE_URL}/all-usertype`, { headers });
      const typeList = response.data?.data;
      setUserType(typeList);
    } catch (error) {
      if (error.response && error.response.status === 401) {
        navigate('/login');
      } else {
        console.error("Error fetching user types:", error);
        setUserType([]);
      }
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (bearer) {
      // fetchUsers(currentPage);
      fetchData1();
      fetchContinents();
      setRegions([{ label: "All Regions", value: "all" }]);
    }
  }, [bearer]);



  const handleCloseCreateUserModal = () => {
    setShowCreateUserModal(false);
    // resetNewUserForm();
  };



  // Skeleton loader
  const SkeletonLoader = () => {
    return (
      <>
        {Array.from({ length: 5 }).map((_, index) => (
          <tr key={index}>
            <td className={classes.textby}><div className={classes.skeleton} style={{ width: '30px', height: '20px' }}></div></td>
            <td className={classes.textby}><div className={classes.skeleton} style={{ width: '120px', height: '20px' }}></div></td>
            <td className={classes.textby}><div className={classes.skeleton} style={{ width: '150px', height: '20px' }}></div></td>
            <td className={classes.textby}><div className={classes.skeleton} style={{ width: '100px', height: '20px' }}></div></td>
            <td className={classes.textby}><div className={classes.skeleton} style={{ width: '80px', height: '20px' }}></div></td>
            <td className={classes.textby}><div className={classes.skeleton} style={{ width: '80px', height: '20px' }}></div></td>
            <td className={classes.textby}><div className={classes.skeleton} style={{ width: '80px', height: '20px' }}></div></td>
            <td className={classes.btnAction}>
              <div style={{ display: 'flex', gap: '10px' }}>
                <div className={classes.skeleton} style={{ width: '20px', height: '20px', borderRadius: '4px' }}></div>
                <div className={classes.skeleton} style={{ width: '20px', height: '20px', borderRadius: '4px' }}></div>
              </div>
            </td>
          </tr>
        ))}
      </>
    );
  };



  // React Select styles
  const selectStyles = {
    container: (provided) => ({
      ...provided,
      width: '100%',
      fontSize: 12,
    }),
    control: (provided) => ({
      ...provided,
      minHeight: "36px",
      fontSize: 12,
    }),
    singleValue: (provided) => ({
      ...provided,
      fontSize: 12,
    }),
    option: (provided, state) => ({
      ...provided,
      fontSize: 12,
      backgroundColor: state.isFocused ? "#f1f5f9" : "white",
      color: "#111827",
    }),
    menu: (provided) => ({
      ...provided,
      maxHeight: "300px",
      overflowY: "auto",
      fontSize: 12,
    }),
    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
  };

  function formatDate(dateString) {
    const date = new Date(dateString);
    const formattedDate = `${date.getFullYear()}-${padZero(date.getMonth() + 1)}-${padZero(date.getDate())} ${padZero(date.getHours())}:${padZero(date.getMinutes())} ${date.getHours() >= 12 ? 'PM' : 'AM'}`;
    return formattedDate;
  }

  function padZero(num) {
    return num < 10 ? `0${num}` : num;
  }




  // const datatoRender = useMemo(() => {
  //   return fetchMode === 'area' ? tableData : tableData1;
  // }, [fetchMode, tableData, tableData1]);

  const handleApprove = async () => {
    setApprovalLoading(true);
    try {
      const response = await axios.post(
        `${BASE_URL1}/fixedassets/approve-assets`,
        {
          id: selectedAsset.id,
        },
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${TOKEN}`,
          },
        }
      );
  
      // Display success message
    
      console.log(response.data.message);
      Swal.fire({
        icon: 'success',
        title: 'Success',
        text: response.data.message,
      });
      navigate(-1);
    } catch (error) {
      let errorMessage = 'An error occurred. Please try again.';
      if (error.response && error.response.data && error.response.data.message) {
          if (typeof error.response.data.message === 'string') {
              errorMessage = error.response.data.message;
          } else if (Array.isArray(error.response.data.message)) {
              errorMessage = error.response.data.message.join('; ');
          } else if (typeof error.response.data.message === 'object') {
              errorMessage = JSON.stringify(error.response.data.message);
          }
        }
      Swal.fire({
        icon: 'success',
        title: 'Success',
        text: errorMessage,
      });
      console.log(error);
    } finally {
      setApprovalLoading(false);
    }
  };
  
  const handleDisApprove = async () => {
    setDisapprovalLoading(true);
    try {
      const response = await axios.post(
        `${BASE_URL1}/fixedassets/disapprove-assets`,
        {
          id: selectedAsset.id,
          description: description
        },
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${TOKEN}`,
          },
        }
      );
      Swal.fire({
        icon: 'success',
        title: 'Success',
        text: response.data.message,
      });
      console.log(response.data);
      navigate(-1);
    } catch (error) {
      let errorMessage = 'An error occurred. Please try again.';
      if (error.response && error.response.data && error.response.data.message) {
          if (typeof error.response.data.message === 'string') {
              errorMessage = error.response.data.message;
          } else if (Array.isArray(error.response.data.message)) {
              errorMessage = error.response.data.message.join('; ');
          } else if (typeof error.response.data.message === 'object') {
              errorMessage = JSON.stringify(error.response.data.message);
          }
      }
      Swal.fire({
        icon: 'error',
        title: 'Failed',
        text: errorMessage,
      });
      console.log(error);
    } finally {
      setDisapprovalLoading(false);
    }
  };

  return (
    <div>
      <HeaderNav />

      {/* Create User Modal */}
      <Modal show={showCreateUserModal} onHide={handleCloseCreateUserModal} size="lg">
        <Modal.Header closeButton>
          <Modal.Title>Create New User & Assign Permissions</Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ padding: '30px' }}>
      
        </Modal.Body>

        <Modal.Footer>

          <Button variant="secondary" onClick={handleCloseCreateUserModal}>Cancel</Button>
          <Button
            className={classes.createUserButton}
            // onClick={createUser}
            variant="primary"
          >
            {createLoading ? <><Spinner size="sm" /> Creating...</> : "Save User & Permissions"}
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Edit User Modal */}
      <Modal show={show1} onHide={handleClose1} size="lg">
        <Modal.Header closeButton>
          <Modal.Title>Update User & Permissions</Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ padding: '30px' }}>
          
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose1}>Cancel</Button>
          <Button
            className={classes.createUserButton}
            // onClick={updateUser}
            variant="primary"
          >
            {createLoading ? <><Spinner size="sm" /> Updating...</> : "Update User & Permissions"}
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Main Content */}
      <div className={classes.topContainer}>

        <div style={{ marginTop: 30 }} />
        <h3 className={classes.topText}>{selectedAsset?.parish?.description}</h3>
        {/* <p className={classes.prgText}>View All Parish.</p> */}

        <Form style={{ marginTop: 20, width: '90%' }}>
                <div className="row">
                  <div className="col-md-6">
                    <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
                      <div className="d-flex align-items-center form-group-custom">
                        <Form.Label className={classes.formLabelCustom122} >Identification Number</Form.Label>
                        <div style={{ width: 500 }}>
                        <Form.Control
          className="formControl" 
          type="text"
          style={{fontSize: "12px"}}
          value={selectedAsset?.identification_number}
          disabled
        />
                      </div>
                      </div>
                    </Form.Group>
                  </div>
                  <div className="col-md-6">
                    <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
                      <div className="d-flex align-items-center form-group-custom">
                      <Form.Label className={classes.formLabelCustom122}>Asset Name</Form.Label>
                      <div style={{ width: 500 }}>
                      <Form.Control
          className="formControl" 
          type="text"
          style={{fontSize: "12px"}}
          value={selectedAsset?.description}
          disabled
        />
                      </div>
                      
                      </div>
                    </Form.Group>
                  </div>
                  <div className="col-md-6">
                    <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
                      <div className="d-flex align-items-center form-group-custom">
                        <Form.Label className={classes.formLabelCustom122}>Category</Form.Label>
                        <div style={{ width: 500, display: "flex", flexDirection: "column" }}>
                        <Form.Control
          className="formControl" 
          type="text"
          style={{fontSize: "12px"}}
          value={selectedAsset?.asset_category?.description}
          disabled
        />
                        </div>
                      </div>
                    </Form.Group>
                       
                  </div>
                  <div className="col-md-6">
                    <Form.Group className="mb-3">
                      <div className="d-flex align-items-center form-group-custom">
                        <Form.Label className={classes.formLabelCustom122}>Amount Purchased</Form.Label>
                        <CurrencyInput
                  name={`amount purchased`}
                  decimalsLimit={2}
                  value={selectedAsset?.amount_purchased}
                  className="form-control"
                  disabled
                  style={{ textAlign: "right", border: "none", width: '100%', fontSize: '12px' }}
                />
                      </div>
                    </Form.Group>
                  </div>
                </div>
                <div className="row" style={{ marginTop: 5 }}>

                  <div className="col-md-6">
                    <Form.Group className="mb-3">
                      <div className="d-flex align-items-center form-group-custom">
                        <Form.Label className={classes.formLabelCustom122}>Proceed on Sale</Form.Label>
                        <CurrencyInput
                  name={`amount sold`}
                  decimalsLimit={2}
                  value={selectedAsset?.proceed_on_sale}
                  className="form-control"
                  disabled
                  style={{ textAlign: "right", border: "none", width: '100%', fontSize: "12px" }}
                />
                      </div>
                    </Form.Group>
                  </div>
                  <div className="col-md-6">
                    <Form.Group className="mb-3">
                      <div className="d-flex align-items-center form-group-custom">
                        <Form.Label className={classes.formLabelCustom122}>Date Purchased</Form.Label>
                        <Form.Control
                              type="date"
                              value={selectedAsset?.date_purchased}
                              style={{fontSize: "12px"}}
                          disabled
                            />

                      </div>
                    </Form.Group>
                  </div>
                </div>

                <div className="row" style={{ marginTop: 5 }}>

                  <div className="col-md-6">
                    <Form.Group className="mb-3">
                      <div className="d-flex align-items-center form-group-custom">
                        <Form.Label className={classes.formLabelCustom122}>Date Disposed</Form.Label>
                        <Form.Control
                        style={{fontSize: "12px"}}
                              type="date"
                              value={selectedAsset?.date_disposed}
                          disabled
                            />
                      </div>
                    </Form.Group>
                  </div>
                  <div className="col-md-6">
                    <Form.Group className="mb-3">
                      <div className="d-flex align-items-center form-group-custom">
                        <Form.Label className={classes.formLabelCustom122}>Lifetime in years</Form.Label>
                        <Form.Control
                        style={{fontSize: "12px"}}
                              type="text"
                              value={selectedAsset?.lifetime_in_years}
                          disabled
                            />

                      </div>
                    </Form.Group>
                  </div>
                </div>

                <div className="row" style={{ marginTop: 5 }}>

                  <div className="col-md-6">
                    <Form.Group className="mb-3">
                      <div className="d-flex align-items-center form-group-custom">
                        <Form.Label className={classes.formLabelCustom122}>Model Number</Form.Label>
                        <Form.Control
                        style={{fontSize: "12px"}}
                              type="text"
                              value={selectedAsset?.model_number}
                          disabled
                            />
                      </div>
                    </Form.Group>
                  </div>
                  <div className="col-md-6">
                    <Form.Group className="mb-3">
                      <div className="d-flex align-items-center form-group-custom">
                        <Form.Label className={classes.formLabelCustom122}>Serial Number</Form.Label>
                        <Form.Control
                        style={{fontSize: "12px"}}
                              type="text"
                              value={selectedAsset?.serial_number}
                          disabled
                            />

                      </div>
                    </Form.Group>
                  </div>
                </div>

                <div className="row" style={{ marginTop: 5 }}>

                  <div className="col-md-6">
                    <Form.Group className="mb-3">
                      <div className="d-flex align-items-center form-group-custom">
                        <Form.Label className={classes.formLabelCustom122}>Quantity</Form.Label>
                        <Form.Control
                              type="text"
                              style={{fontSize: "12px"}}
                              value={selectedAsset?.quantity}
                          disabled
                            />
                      </div>
                    </Form.Group>
                  </div>
                  <div className="col-md-6">
                    <Form.Group className="mb-3">
                      <div className="d-flex align-items-center form-group-custom">
                        <Form.Label className={classes.formLabelCustom122}>Unit Price</Form.Label>
                        <CurrencyInput
                  name={`amount sold`}
                  decimalsLimit={2}
                  value={selectedAsset?.unit_price}
                  className="form-control"
                  disabled
                  style={{ textAlign: "right", border: "none", width: '100%', fontSize: "12px" }}
                />

                      </div>
                    </Form.Group>
                  </div>
                </div>

                <div className="row" style={{ marginTop: 5 }}>

                  <div className="col-md-6">
                    <Form.Group className="mb-3">
                      <div className="d-flex align-items-center form-group-custom">
                        <Form.Label className={classes.formLabelCustom122}>Location</Form.Label>
                        <Form.Control
                              type="text"
                              value={selectedAsset?.location}
                              style={{fontSize: "12px"}}
                          disabled
                            />
                      </div>
                    </Form.Group>
                  </div>
                  <div className="col-md-6">
                    <Form.Group className="mb-3">
                      <div className="d-flex align-items-center form-group-custom">
                        <Form.Label className={classes.formLabelCustom122}>Residual Value</Form.Label>
                        <CurrencyInput
                  name={`amount sold`}
                  decimalsLimit={2}
                  value={selectedAsset?.residual_value}
                  className="form-control"
                  disabled
                  style={{ textAlign: "right", border: "none", width: '100%', fontSize: "12px" }}
                />

                      </div>
                    </Form.Group>
                  </div>
                </div>

                <div className="row" style={{ marginTop: 5 }}>

                  <div className="col-md-6">
                    <Form.Group className="mb-3">
                      <div className="d-flex align-items-center form-group-custom">
                        <Form.Label  className={classes.formLabelCustom122}>Supporting Document</Form.Label>
                        <Form.Control
                              type="file"
                              style={{fontSize: "12px"}}
                              // value={selectedAsset?.location}
                          disabled
                            />
                      </div>
                    </Form.Group>
                  </div>
                  <div className="col-md-6">
                    <Form.Group className="mb-3">
                      <div className="d-flex align-items-center form-group-custom">
                        <Form.Label className={classes.formLabelCustom122}>Remarks</Form.Label>
                        <Form.Control
                              type="text"
                              style={{fontSize: "12px"}}
                              value={selectedAsset?.remarks}
                          disabled
                            />

                      </div>
                    </Form.Group>
                  </div>
                </div>
                
               
       
      </Form>

        <div style={{ marginTop: 24 }} />

        <div className={classes.buttonsGroup}>
   <div style={{display: "flex", justifyContent: "center", alignItems: "center"}}>
   <div className="row" style={{maxWidth: "100%", marginTop: 30}}>
      <h5 style={{ textAlign: "left" }}>Document(s) Uploaded</h5>
      {selectedAsset?.documents && selectedAsset?.documents?.length > 0 ? (
                                                            <div style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'center' }}>
                                                              {selectedAsset.documents.map((document, index) => (
                                                                <div key={index} style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', margin: '20px', textAlign: 'center' }}>
                                                                  {document.pdf_file.toLowerCase().endsWith('.pdf') ? (
                                                                    <span title={document.pdf_file}>
                                                                      <img src={Pdf} alt="PDF Icon" style={{ width: '100px', height: '100px', cursor: 'pointer' }} onClick={() => window.open(document.pdf_file, '_blank')} />
                                                                      <div style={{ marginTop: '5px' }}>
                                                                        {document.pdf_file.length > 20 ? `${document.pdf_file.substring(0, 20)}...` : document.pdf_file}
                                                                      </div>
                                                                    </span>
                                                                  ) : (
                                                                    <span title={document.pdf_file}>
                                                                      <img src={Pic} alt="Document" style={{ width: '100px', height: '100px', cursor: 'pointer' }} onClick={() => window.open(document.pdf_file, '_blank')} />
                                                                      <div style={{ marginTop: '5px' }}>
                                                                        {document.pdf_file.length > 20 ? `${document.pdf_file.substring(0, 20)}...` : document.pdf_file}
                                                                      </div>
                                                                    </span>
                                                                  )}
                                                                </div>
                                                              ))}
                                                            </div>
                                                          ) : (
                                                            <p>No document uploaded</p>
                                                          )}

                  
                </div>
            </div>
          

            <div style={{marginTop: 50}} className={classes.bttn}>
              <Button variant="light" className={classes.btn1} onClick={goBack}> Cancel</Button>
              {selectedAsset?.approval_status === "1" && (
    <>
              <Button  style={{ borderRadius: 5 }} variant='success' onClick={handleApprove}>
                {approvalLoading ? (
                            <>
                              <Spinner size='sm' />
                              <span style={{ marginLeft: '5px' }}>Processing, Please wait...</span>
                            </>
                          ) : (
                            "Approve"
                          )}
             
              </Button>
              <Button  style={{ borderRadius: 5 }} variant='danger' onClick={handleDisApprove}>
                {disApprovalLoading ? (
                            <>
                              <Spinner size='sm' />
                              <span style={{ marginLeft: '5px' }}>Processing, Please wait...</span>
                            </>
                          ) : (
                            "Disapprove"
                          )}
                
              </Button>
              </>
)}
            </div>
          </div>

        {/* <div className={classes.tableContainer}>
          <table className={classes.tableTable}>
            <thead className={classes.tableHeader}>
              <tr>
                <th>#</th>
                <th>Identification Number</th>
                                            <th>Asset Name</th>
                                            <th>Category</th>
                                            <th>Quantity</th>
                                            <th>Amount</th>
                                            <th>Approval Status</th>
                                            <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {loading || processLoading ? (
                <SkeletonLoader />
              ) : tableData.length > 0 ? (
                tableData.map((item, index) => (
                  <tr key={index}>
                                              <td className={classes.textby}  >{index + 1}</td>
                                              <td className={classes.textby} style={{paddingLeft: 20}} >
                                                {item.identification_number}
                                              </td>
                                              <td className={classes.textby} style={{paddingLeft: 15}}>{item.description}</td>
                                              <td
                                              className={classes.textby}
                                                style={{ whiteSpace: "wrap" }}
                                              >
                                                {
                                                  item.asset_category
                                                    ?.description
                                                }
                                              </td>
                                              <td className={classes.textby} style={{paddingLeft: 30}}>{item.quantity}</td>
                                              <td className={classes.textby} >{item.amount_purchased}</td>
                                              <td className={classes.textby} >
                                                <Badge
                                                  style={{ padding: 10 }}
                                                  bg={
                                                    item.approval_status === "0"
                                                      ? "warning"
                                                      : item.approval_status ===
                                                        "1"
                                                      ? "success"
                                                      : item.approval_status ===
                                                        "2"
                                                      ? "success"
                                                      : item.approval_status ===
                                                        "3"
                                                      ? "danger"
                                                      : ""
                                                  }
                                                >
                                                  {item.approval_status === "0"
                                                    ? "Pending Approval"
                                                    : item.approval_status ===
                                                      "1"
                                                    ? "Checker Approved"
                                                    : item.approval_status ===
                                                      "2"
                                                    ? "Regional Approved"
                                                    : item.approval_status ===
                                                      "3"
                                                    ? "Disapproved"
                                                    : ""}
                                                </Badge>
                                              </td>
                                              <td
                                                style={{ whiteSpace: "nowrap", paddingLeft: 20 }}
                                              >
                                                <div
                                                  onClick={() =>
                                                    handleEyeClick(item.id)
                                                  }
                                                  className="btn btn-success-soft btn-sm mr-1"
                                                >
                                                <Pencil
                                                    size={14}
                                                    color="#008a4b"
                                                    style={{
                                                      color: "#008a4b",
                                                      backgroundColor:
                                                        "#28a7451a",
                                                      padding: 2,
                                                      borderColor: "#28a7454d",
                                                      borderRadius: 5,
                                                      fontSize: 12,
                                                    }}
                                                  />
                                                </div>
                                              </td>
                                            </tr>
                ))
              ) : (
                <tr style={{fontSize: "12px"}}>
                  <td colSpan="7" className="text-center p-4" style={{ color: '#6c757d' }}>
                    {searchTerm ? `No area found matching "${searchTerm}"` : "No area available."}
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div> */}

       
        {/* <div className={classes.paginationStyle}>
          <div className={classes.footerSubOne}>
            <button
              className={classes.btnFirst}
              onClick={handleFirstPage}
              disabled={currentPage === 1}
            >
              First
            </button>
            <span className={classes.ftOne}>
              {getPageNumbers().map(pageNum => (
                <button
                  key={pageNum}
                  className={`${classes.pageNumber} ${currentPage === pageNum ? classes.active : ''}`}
                  onClick={() => handlePageClick(pageNum)}
                >
                  {pageNum}
                </button>
              ))}
            </span>
            <button
              className={classes.btnSec}
              onClick={handleLastPage}
              disabled={currentPage === totalPages}
            >
              Last
            </button>
          </div>
          <p className={classes.displayPag}>
            Displaying {(currentPage - 1) * perPage + 1}-{Math.min(currentPage * perPage, totalUsers)} of {totalUsers} users
          </p>
        </div> */}
      </div>
    </div>
  )
}

export default ViewAsset;